"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface COMCTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  { 
    id: "comc-1", 
    question: "Does the entity have material related party transactions in this ABCOTD?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
];

export default function COMCTailoringQuestions({ onBack }: COMCTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Cost of Materials Consumed"
      title="Cost of Materials Consumed - Tailoring Questions"
      description="Answer the following Yes/No question."
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}


